<template>
  <div class="container_box">
    <div class="bg">
      <img src="../assets/imgs/banner1-1.png" alt="" />
    </div>
    <div class="content pt-15">
      <!-- 竞价大厅标题 -->
      <div class="flex between mb-20">
        <div class="bold9 size20 color1">
          竞价列表-竞价详情
          <!-- <span style="font-size: 14px; color: #ccd9e9"
            >Bidding Hall</span
          > -->
        </div>
        <div class="color-aaa color2" style="margin-top: 4px">
          浏览量{{ jingJiaDetail.views }}
        </div>
      </div>
      <!-- 竞价公告 -->
      <div style="margin-top: 46px">
        <div
          style="
            font-size: 14px;
            color: #3b426b;
            margin-bottom: 14px;
            font-weight: bold;
          "
        >
          竞价公告
        </div>

        <el-descriptions
          :column="2"
          border
          labelClassName="my-label"
          contentClassName="my-content"
        >
          <el-descriptions-item
            label="竞价标题"
            label-class-name="my-label"
            content-class-name="my-content"
            >{{ jingJiaDetail.title }}</el-descriptions-item
          >
          <el-descriptions-item label="发起单位">{{
            jingJiaDetail.publishCompany
          }}</el-descriptions-item>
          <el-descriptions-item label="场次号">{{
            jingJiaDetail.sessionNum
          }}</el-descriptions-item>
          <el-descriptions-item label="最终用户">{{
            jingJiaDetail.finalUser
          }}</el-descriptions-item>
          <el-descriptions-item label="竞价开始时间">{{
            jingJiaDetail.beginTime
          }}</el-descriptions-item>
          <el-descriptions-item label="联系人">{{
            jingJiaDetail.linker
          }}</el-descriptions-item>
          <el-descriptions-item label="竞价结束时间">{{
            jingJiaDetail.endTime
          }}</el-descriptions-item>
          <el-descriptions-item label="联系方式">{{
            jingJiaDetail.linkMode
          }}</el-descriptions-item>
          <el-descriptions-item label="来源">{{
            jingJiaDetail.source
          }}</el-descriptions-item>
          <el-descriptions-item label="付款方式">{{
            jingJiaDetail.payMode == 1 ? "一次性付清" : "阶段性付清"
          }}</el-descriptions-item>
          <el-descriptions-item label="参与方式">{{
            jingJiaDetail.participationMode == 1 ? "公开" : "非公开"
          }}</el-descriptions-item>
          <el-descriptions-item label="出价方式">{{
            jingJiaDetail.biddingMode == 1 ? "连续报价" : "连续报价"
          }}</el-descriptions-item>
          <!-- <el-descriptions-item label="附件">
            <div class="pointer" @click="upload">下载</div>
          </el-descriptions-item> -->
          <!-- <el-descriptions-item label="备注">
           {{jingJiaDetail.}}
          </el-descriptions-item> -->
        </el-descriptions>
      </div>
      <!-- 竞价产品明细 -->
      <div style="margin-top: 30px">
        <div
          style="
            font-size: 14px;
            color: #3b426b;
            margin-bottom: 14px;
            font-weight: bold;
          "
        >
          竞价产品明细
        </div>
        <!-- 表格 -->
        <el-table
          :header-cell-style="{
            background: '#3B426C',
            color: '#ffffff',
            padding: '0px',
            height: '40px',
          }"
          :cell-style="{ padding: '0px' }"
          :row-style="{ height: '40px' }"
          class="table2 mb-10"
          :data="tableData2"
          stripe
          style="font-size: 14px"
        >
          <el-table-column prop="subTitle" label="分包标题" align="center">
            <template></template>
          </el-table-column>
          <el-table-column prop="productName" label="产品名称" align="center">
            <template></template>
          </el-table-column>
          <el-divider direction="vertical"></el-divider>
          <el-table-column prop="productSpec" label="规格型号" align="center">
          </el-table-column>
          <el-table-column prop="specReplace" label="型号可替代" align="center">
          </el-table-column>
          <el-table-column prop="purchaseNum" label="采购数量" align="center">
          </el-table-column>
          <el-table-column prop="unit" label="计量单位" align="center">
          </el-table-column>
          <el-table-column prop="arrivalDate" label="到货日期" align="center">
          </el-table-column>
          <el-table-column prop="arrivalPlace" label="到货地点" align="center">
          </el-table-column>
          <el-table-column prop="remark" label="备注" align="center">
          </el-table-column>
          <el-table-column prop="remark" label="操作" align="center">
            <template slot-scope="scope">
              <span
                v-if="scope.row.productDetail"
                class="pointer"
                @click="downFile(scope.row.productDetail)"
                >下载明细清单</span
              >
            </template>
          </el-table-column>
        </el-table>
      </div>

      <!-- 按钮 -->
      <div class="flex items-center flex-center">
        <div
          class="btn"
          v-if="
            jingJiaDetail.status == 1 && jingJiaDetail.participationStatus == 2
          "
          @click="goCanYu"
        >
          我要参与
        </div>
        <div
          @click="weiKaiShi"
          class="btn pointer wei"
          v-if="
            jingJiaDetail.status == 1 && jingJiaDetail.participationStatus == 1
          "
        >
          未开始
        </div>
        <div
          class="btn"
          v-if="
            jingJiaDetail.status != 1 &&
            jingJiaDetail.status != 5 &&
            jingJiaDetail.participationStatus == 1
          "
          @click="jingjia"
        >
          我要竞价
        </div>

        <div class="btn ml-10" @click="goGongGao">竞价公告</div>
      </div>
    </div>

    <Footer class="mt-15" />
    <Result
      :title="resultTitle"
      :SubTitle="subTitle"
      :isShow="resultShow"
      @change="resultClose"
    />
  </div>
</template>

<script>
import Footer from "@/components/Footer";
import Result from "@/components/Result";

export default {
  components: { Footer, Result },

  data() {
    return {
      resultTitle: "",
      subTitle: "",
      resultShow: false,
      message: "",
      tableData: [],
      tableData2: [],
      total: "",
      bid: window.sessionStorage.getItem("jjId"),
      jingJiaDetail: {},
      jiLuList: [],
    };
  },
  mounted() {
    this.getJingJiaDetail();
    // this.getBaoJiaList();
  },
  methods: {
    resultClose() {
      this.resultShow = false;
    },
    downFile(file) {
      if (!file) {
        this.resultTitle = "下载失败";
        this.subTitle = "未上传明细清单";
        this.resultShow = true;
        return;
      }
      let url = file.slice(file.indexOf("/profile/upload") + 15);
      // window.open("http://81.70.253.119:8081/common/download?fileName=" + url);
	  window.open(this.$static.SERVER_URL + "/common/download?fileName=" + url);
    },
    //跳转竞价公告
    async goGongGao() {
      const { data: res } = await this.$axios.get("/api/annInfo/getAnnByBid", {
        params: {
          biddingId: this.bid,
        },
      });
      console.log(res);
      if (res.code == 200) {
        this.$router.push({
          path: "/jingjiadetail",
          query: { id: res.data },
        });
      } else {
        this.resultTitle = "暂无公告";
        this.subTitle = "";
        this.resultShow = true;
        return;
      }
    },
    //点击未开始
    async weiKaiShi() {
      const { data: res } = await this.$axios.get(
        "/api/biddingInfo/getBiddingDetail",
        {
          params: {
            biddingId: this.bid,
            userId: window.sessionStorage.getItem("userId"),
          },
        }
      );
      if (res.code == 200) {
        this.jingJiaDetail = res.data;
      }
      if (this.jingJiaDetail.status == 1) {
        this.resultTitle = "操作失败";
        this.subTitle = "竞价未开始";
        this.resultShow = true;
        return;
      } else {
        this.$router.push("/jjxz");
      }
    },
    //点击我要参与
    async goCanYu() {
      if (!window.sessionStorage.getItem("userId")) {
        this.resultTitle = "未登录";
        this.subTitle = "请先登录";
        this.resultShow = true;

        return;
      }
      this.getJingJiaDetail();
      if (this.jingJiaDetail.participationStatus == 1) {
        return;
      }
      const { data: res } = await this.$axios({
        url: "/api/supplierService/submitBiddingSignup",
        method: "post",
        params: {
          userId: window.sessionStorage.getItem("userId"),
          biddingId: this.bid,
        },
        headers: {
          token: window.sessionStorage.getItem("token"),
        },
      });
      // console.log(res);
      if (res.code == 200) {
        this.resultTitle = "报名成功";
        this.subTitle = res.msg;
        this.resultShow = true;
        this.getJingJiaDetail();
      } else {
        this.resultTitle = "报名失败";
        this.subTitle = res.msg;
        this.resultShow = true;
      }
    },
    //获取分包详情
    //获取竞价详情
    async getJingJiaDetail() {
      const { data: res } = await this.$axios.get(
        `/api/biddingInfo/getBiddingDetail`,
        {
          params: {
            biddingId: this.bid,
            userId: window.sessionStorage.getItem("userId"),
          },
        }
      );
      console.log(res);
      if (res.code == 200) {
        this.jingJiaDetail = res.data;
        this.tableData2 = [];
        res.data.subDetailList.some((item) => {
          let obj = {};
          if (item.productList.length > 0) {
            obj.id = item.id;
            obj.productDetail = item.productDetail;

            obj.subTitle = item.subTitle;
            item.productList.some((subItem) => {
              obj.productName = subItem.productName;
              obj.productSpec = subItem.productSpec;
              obj.specReplace = subItem.specReplace;
              obj.purchaseNum = subItem.purchaseNum;
              obj.unit = subItem.unit;
              obj.arrivalDate = subItem.arrivalDate;
              obj.arrivalPlace = subItem.arrivalPlace;
              obj.remark = subItem.remark;
            });
          }

          this.tableData2.push(obj);
        });
        console.log(this.tableData2);
      } else {
        this.resultTitle = "获取详情失败";
        this.subTitle = res.msg;
        this.resultShow = true;
      }
    },

    jingjia() {
      if (!window.sessionStorage.getItem("userId")) {
        this.resultTitle = "未登录";
        this.subTitle = "请先登录";
        this.resultShow = true;

        return;
      }
      window.sessionStorage.setItem("jjId", this.jingJiaDetail.id);
      window.sessionStorage.setItem("jjStatus", this.jingJiaDetail.status);
      this.$router.push("/jjxz");
    },
    upload() {
      this.resultTitle = "下载成功";
      this.subTitle = "";
      this.resultShow = true;
    },
    select() {
      this.$message.closeAll();
      this.$message.success("预览成功");
    },
  },
};
</script>

<style scoped lang="less">
.content_box {
  background: url("../assets/imgs/bg.png") no-repeat;
  padding-bottom: 43px;
}
.content {
  width: 1200px;
  margin: auto;
  .jingjia-box {
    .row {
      height: 46px;
      line-height: 46px;
      color: #3b426b;
      .col {
        width: 180px;
        border: 1px solid #ccd9e9;
        border-right: none;
        text-align: center;
      }
      .col2 {
        width: 180px;
        border: 1px solid #ccd9e9;
        border-right: none;
        text-align: center;
      }
      .col1 {
        width: 420px;
        border: 1px solid #ccd9e9;
        border-right: none;
        text-align: center;
        .blue-color {
          color: #1c65c4;
        }
      }
      .col3 {
        width: 420px;
        border: 1px solid #ccd9e9;
        text-align: center;
      }
    }
  }
}
/deep/.el-table--striped .el-table__body tr.el-table__row--striped td {
  background-color: #f3f6fb !important;
}
/deep/.el-table__header tr.el-table__header th {
  padding: 0 !important;
}
/deep/.el-table__body tr.el-table__body td {
  padding: 0 !important;
}
/deep/.table2.el-table th.el-table__cell > .cell {
  border-right: 1px solid #fff;
}
/deep/.table2.el-table .cell {
  border-right: 1px solid #95b3db;
}
/deep/.table2.el-table td.el-table__cell {
  border-bottom: none;
}
.btn {
  // margin: auto;
  width: 120px;
  height: 40px;
  border-radius: 25px;
  margin-top: 36px;
  font-size: 14px;
  color: #fff;
  font-weight: bold;
  background-color: #1c65c4;
  text-align: center;
  line-height: 40px;
  cursor: pointer;
}
</style>